module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_01-ddcbcbd9bbf2bae6409d229898b47cee.png";